// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/clockDayOffset.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9206 follow-up: ONE calendar-day-offset rule, client + server.)
//
// Side-effect module: attaches `window.ClockDay`. app.js imports it immediately
// BEFORE sharedFormat.js, whose `Fmt.shiftSpan` / `Fmt.shiftCells` call
// `window.ClockDay.localDaySerial(d, window.ClockDay.RUNTIME_LOCAL_ZONE)` — a
// window global read at CALL time, never a cross-`?v=` ES import (Pitfall #1).
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  /** Fallback when a tenant's `settings.timezone` is empty or unusable. */
  const DEFAULT_TIME_ZONE = 'America/Chicago';

  /**
   * Pass this as the zone to resolve the calendar day in the RUNTIME's OWN zone
   * (the viewer's browser). Deliberately not a valid IANA name and deliberately
   * not the default: a caller that wants the viewer's day has to say so.
   */
  const RUNTIME_LOCAL_ZONE = '@@RUNTIME_LOCAL@@';

  /**
   * An IANA name this runtime can actually format with, resolving a bad one to
   * the default ONCE so the time and the date on the same cell can never disagree
   * about which wall clock they are on. `settings.timezone` is tenant-writable
   * free text, so the cache is capped: it is keyed by a value a tenant can invent.
   */
  const _USABLE_ZONE = new Map();
  function resolveUsableZone(timeZone) {
    const tz = String(timeZone == null ? '' : timeZone).trim() || DEFAULT_TIME_ZONE;
    if (_USABLE_ZONE.has(tz)) return _USABLE_ZONE.get(tz);
    let ok = DEFAULT_TIME_ZONE;
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: tz }).format(new Date(0));
      ok = tz;
    } catch (e) {
      ok = DEFAULT_TIME_ZONE;
    }
    if (_USABLE_ZONE.size > 200) _USABLE_ZONE.clear();
    _USABLE_ZONE.set(tz, ok);
    return ok;
  }

  const _DAY_PARTS_FMT = new Map();
  function dayPartsFormatter(zone) {
    let f = _DAY_PARTS_FMT.get(zone);
    if (!f) {
      f = new Intl.DateTimeFormat('en-US', { timeZone: zone, year: 'numeric', month: 'numeric', day: 'numeric' });
      if (_DAY_PARTS_FMT.size > 200) _DAY_PARTS_FMT.clear();
      _DAY_PARTS_FMT.set(zone, f);
    }
    return f;
  }

  /**
   * The calendar-day serial of an instant IN THE GIVEN ZONE.
   *
   * With an IANA zone the parts come from `Intl`, not from `getFullYear()` —
   * those are the RUNTIME's local parts, which in Cloud Functions is UTC.
   * With `RUNTIME_LOCAL_ZONE` they come from the local getters on purpose: that
   * IS the question the viewer's browser is asking, and it needs no `Intl` call.
   *
   * @returns {number|null} null when the instant cannot be resolved at all — and
   *   every caller treats null as "not crossing", because an unknown offset must
   *   never invent a date on a customer's document.
   */
  function localDaySerial(d, timeZone) {
    if (!(d instanceof Date) || isNaN(d.getTime())) return null;
    if (timeZone === RUNTIME_LOCAL_ZONE) {
      return Math.round(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000);
    }
    let parts;
    try {
      parts = dayPartsFormatter(resolveUsableZone(timeZone)).formatToParts(d);
    } catch (e) {
      return null;
    }
    let y = null; let m = null; let day = null;
    for (const p of parts) {
      if (p.type === 'year') y = Number(p.value);
      else if (p.type === 'month') m = Number(p.value);
      else if (p.type === 'day') day = Number(p.value);
    }
    if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(day)) return null;
    return Math.round(Date.UTC(y, m - 1, day) / 86400000);
  }

  /** Local calendar days crossed by a window. 0 = same day, or not knowable. */
  function clockDayOffset(fromDate, toDate, timeZone) {
    const a = localDaySerial(fromDate, timeZone);
    const b = localDaySerial(toDate, timeZone);
    if (a === null || b === null) return 0;
    return b - a;
  }

  window.ClockDay = {
    DEFAULT_TIME_ZONE: DEFAULT_TIME_ZONE,
    RUNTIME_LOCAL_ZONE: RUNTIME_LOCAL_ZONE,
    resolveUsableZone: resolveUsableZone,
    dayPartsFormatter: dayPartsFormatter,
    localDaySerial: localDaySerial,
    clockDayOffset: clockDayOffset
  };
})();
